<template>
    <div class="posterList">
        <div class="titleBox">
            <p class="title">活动名称：<span>{{this.name}}</span></p>
        </div>
        <div class="posterBox">
            <div class="list">
                <div :class="{'item':true, 'select': select === index}" v-for="(item, index) in posterList" :key="index" @click="choicePoster(index)">
                    <img :src="item.coveratturlid" alt="">
                </div>
                <div class="addBox">
                    <img :src="require('@/common/images/nationalDistributionMenu/add_poster.png')" @click="addPoster" alt="">
                </div>
            </div>
            <div class="btnBox">
                <el-button type="success" class="edit" :disabled="select === ''" @click.native="editPoster">编辑</el-button>
                <el-button class="delete" type="danger" :disabled="select === ''" @click.native="deletePoster">删除</el-button>
                <el-button class="cancel" @click="cancel">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {getPosterList, deleteSinglePoster} from 'api/nationalDistribution'
export default {
    name: 'posterList',
    data() {
        return {
            posterList: [],
            select: '',
            name: ''
        }
    },
    created() {
        this.getPosterList()
    },
    methods: {
        editPoster() {
            this.$router.push({name: 'NDPosterSet', query: {posterinnerid: this.posterList[this.select].innerid, eventinnerid: this.$route.query.innerid}})
        },
        deletePoster() {
            if (this.posterList.length > 1) {
                this.$confirm('确定删除该海报吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.setLoading(true)
                    deleteSinglePoster({
                        data: {eventinnerid: this.posterList[this.select].eventinnerid, innerid: this.posterList[this.select].innerid},
                        success: data => {
                            this.setLoading(false)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            this.getPosterList()
                        },
                        error: data => {
                            this.setLoading(false)
                        }
                    })
                }).catch(() => {  
                })
            } else {
                this.$message.error('至少保留一张海报哦！')
            }
        },
        addPoster() {
            this.$router.push({name: 'NDPosterSet', query: {eventinnerid: this.$route.query.innerid}})
        },
        getPosterList() {
            this.setLoading(true)
            getPosterList({
                data: {eventinnerid: this.$route.query.innerid},
                success: data => {
                    this.setLoading(false)
                    this.posterList = data.data
                    this.name = data.data[0].title
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        choicePoster(index) {
            this.select = index
            console.log(this.select)
        },
        cancel() {
            this.$router.push({name: 'NDActivityList'})
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    }
}
</script>
<style lang="scss">
    .posterList{
        background: #fff;
        padding: 20px 0 0;
        .titleBox{
            padding: 0 20px 20px;
            border-bottom: 1px solid #DCDFE6;
            .title{
                padding-left: 8px;
                border-left: 2px solid #409EFF;
                font-size: 16px;
                font-weight: 500;
                span{
                    color: #909399;
                }
            }
        }
        .posterBox{
            padding: 20px 40px;
            .list{
                display: flex;
                .item{
                    margin-right: 30px;
                    width: 135px;
                    height: 240px;
                    box-sizing: border-box;
                    img{
                        width: 133px;
                        height: 238px;
                        cursor: pointer;
                    }
                }
                .select{
                    border: 1px solid #409EFF;
                }
                .addBox{
                    img{
                        width: 135px;
                        height: 240px;
                        cursor: pointer;
                    }
                }
            }
            .btnBox{
                display: flex;
                margin-top: 10px;
                div{
                    width: 60px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    color: #fff;
                    margin-right: 15px;
                    font-size: 12px;
                    cursor: pointer;
                }
                .edit{
                    background: #67C23A;
                }
                .delete{
                    background: #F56C6C;
                }
            }
        }
    }
</style>